import React from 'react'
import { User } from '../../models/User'
import { UserConsent, UserConsentState } from './model'
import styled from 'styled-components'
import { ReactComponent as UserShield } from '../../assets/images/user-shield.svg'
import { parseMetadata } from '../../apps/professional-app/fa/MeetingSummary/utils'

const ConsentContainer = styled.div`
  display: inline-flex;
  height: 1.5rem;
  padding: 0.125rem 0.5rem;
  justify-content: center;
  align-items: center;
  gap: 0.25rem;
  border-radius: 0.25rem;
`

type ConsentIconProps = {
  contact: User
  container?: React.ElementType
  role?: string
  showText?: boolean
  consent?: UserConsent | null
  onClick?: (args: any) => any
}
const consentIcon: { [key: string]: any } = {
  unknown: {
    text: 'Unknown',
    logo: 'bi bi-question',
    classNames: 'zocks-bg-color-gray-200 zocks-text-gray-600',
    shieldColor: '#6C757D',
  },
  refused: {
    text: 'Refused',
    logo: 'bi bi-x',
    classNames: 'zocks-bg-color-danger-background zocks-text-danger-200',
    shieldColor: '#BA2735',
  },
  revoked: {
    text: 'Revoked',
    logo: 'bi bi-arrow-left-short',
    classNames: 'zocks-bg-color-warning zocks-text-warning-text',
    shieldColor: '#BB8110',
  },
  accepted: {
    text: 'Accepted',
    logo: 'bi bi-check',
    classNames: 'zocks-bg-color-success-background zocks-text-success-200',
    shieldColor: '#267A39',
  },
}
export const ConsentIcon: React.FC<ConsentIconProps> = ({ consent, contact, container, showText = true, role, onClick }) => {
  const metadata = parseMetadata(contact.metadata ?? '')
  const userConsent = consent ?? (typeof metadata === 'object' && metadata !== null && metadata.zocksConsent)
  const consentState = userConsent?.current?.state ? userConsent.current?.state : UserConsentState.UNKNOWN

  return <SimpleConsentIcon consentState={consentState} showText={showText} container={container} role={role} onClick={onClick} />
}

export interface SimpleConsentIconProps {
  consentState: UserConsentState
  showText?: boolean
  container?: React.ElementType
  role?: string
  onClick?: (args: any) => any
}

export const SimpleConsentIcon: React.FC<SimpleConsentIconProps> = ({ consentState, showText = true, container, role, onClick }) => {
  const icon = consentIcon[consentState]
  const Container = container || ConsentContainer
  return (
    <Container role={role} className={icon.classNames} onClick={onClick}>
      <UserShield fill={icon.shieldColor} /> {showText && icon.text}
    </Container>
  )
}
